@if (pTimeSpec$ | async; as spec) {
  <div class="layout-col full">
    <!-- Header Section -->
    <div class="layout-row">
      @if (!embedded) {
        <mat-toolbar elderTheme class="gap-md">
          <button mat-icon-button (click)="onClose($event)">
            <mat-icon>close</mat-icon>
          </button>
          <elder-header
            [header]="
              (creationMode ? 'skillSets.capacities.new' : 'skillSets.capacities.capacity')
                | translate
            "
            [subheader]="creationMode ? ' ' : 'ID: ' + spec.id"
          >
          </elder-header>
          <span class="flex"></span>
          <button mat-icon-button [disabled]="!constraintFrm.form.valid" (click)="onSave($event)">
            <mat-icon>save</mat-icon>
          </button>
        </mat-toolbar>
      }
    </div>
    <!-- Content -->
    <form #constraintFrm="ngForm" class="flex layout-col p-xl">
      <div class="flex layout-row place-start-center gap-md">
        <mat-form-field>
          <mat-label>{{ 'properties.property' | translate }}</mat-label>
          <elder-select
            name="productProperty"
            appPropertySelect
            productKind
            class="flex"
            required
            [(ngModel)]="spec.property"
            (valueChange)="productPropertySelectionChanged($event)"
          >
            <div *elderSelectValue="let value" class="layout-col">
              <span style="line-height: 20px">{{ value.description }}</span>
              <span class="mat-caption">{{ value.id }}</span>
            </div>
            <app-property-browser *elderSelectionModelPopup class="flex" productKind>
            </app-property-browser>
          </elder-select>
        </mat-form-field>
      </div>
      <div class="flex layout-row place-start-center gap-md">
        <mat-form-field>
          <elder-select
            elderUnitSelect
            name="unit"
            class="flex"
            [baseUnit]="spec.property?.unit"
            required
            valueAsId
            [(ngModel)]="spec.unit"
          >
          </elder-select>
        </mat-form-field>
        <mat-form-field class="flex">
          <mat-label>{{ 'context.group' | translate }}</mat-label>
          <input
            matInput
            name="group"
            type="number"
            required
            placeholder="{{ 'context.group' | translate }}"
            [(ngModel)]="spec.setNumber"
          />
        </mat-form-field>
      </div>
      <div class="flex layout-row gap-md">
        <mat-form-field class="flex">
          <mat-label>{{ 'context.description' | translate }}</mat-label>
          <input
            matInput
            name="description"
            placeholder="{{ 'context.description' | translate }}"
            [(ngModel)]="spec.description"
          />
        </mat-form-field>
      </div>
    </form>
  </div>
}
